export class InvestigationDashboardPreferencesEntity {
  public hiddenPredefinedFilterIds!: string[];
  public hiddenColumnKeys!: string[];
  public columnOrder!: string[] | null;
  public advancedFilterRows!: string | null;
  public showCharts!: boolean;
  public selectedTimeframe!: string;
  public filterFromDate!: string | null;
  public filterToDate!: string | null;
  public canCreateInvestigation!: boolean;
}
